export default {
  // / <summary>
  // / Đang upload
  // / </summary>
  Uploading: 0,
  /**
   * Thành công
   */
  Success: 1,
  /**
   * Lỗi
   */
  Error: 1,
};
